import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {
  getSelectedOrderFromOrdersSearch,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../../../../extractFromState';
import { getSelectedLineItems } from '../../../../../../selectors/tools';
import { cancelAndRefundOrderItems } from '../../../../../../actions/tools/CommonAsyncOrderActions';
import DTSelectedItemTransactionView from '../../DTSelectedItemTransactionView';
import { useReasons } from '../../../../../../customHooks/decisionTree/useReasons';
import { BlankReasonContainer } from '../../../../Common/DTSelectReason/DTSelectReason.styles';
import { withConfirmation } from '../../../../DTConfirmationView/withConfirmation';
import { setShowConfirmationPage } from '../../../../../../actions/tools/OrdersSearchActions';
import { setLoading } from '../../../../../../actions';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { REASON_TYPES } from 'constants/decisionTree';

const DTRefundAndCancelSelectedItemsNode = () => {
  const dispatch = useDispatch();
  const selectedLineItems = useSelector(getSelectedLineItems);
  const orderId = get(useSelector(getSelectedOrderFromOrdersSearch), 'orderId');
  const domain = get(useSelector(getSelectedOrderFromOrdersSearch), 'simplrParams.domain');
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);

  const { selectedReason, reasons, ReasonContainerComponent } = useReasons({
    loadingComponentName: 'itemTransactionContainer',
    skipImages: true,
    type: REASON_TYPES.CANCEL_AND_REFUND,
  });

  const isCancelReasonsRequired = !isEmpty(reasons);

  const handleRefundButtonClick = async () => {
    try {
      dispatch(setLoading(true, 'itemTransactionContainer'));
      await dispatch(
        cancelAndRefundOrderItems({
          simplrAccountId,
          orderId,
          items: selectedLineItems,
          reason: selectedReason,
          domain,
        })
      );
      dispatch(setShowConfirmationPage());
    } catch (error) {
      dispatch(addEdgeToDecisionTreePath('transaction_failed'));
    } finally {
      dispatch(setLoading(false, 'itemTransactionContainer'));
    }
  };

  return (
    <DTSelectedItemTransactionView
      nextButtonLabel="EXECUTE ACTION"
      showContainer={!!reasons}
      isNextEnabled={!!selectedReason || !isCancelReasonsRequired}
      nextButtonClickHandler={handleRefundButtonClick}
    >
      {isCancelReasonsRequired ? <ReasonContainerComponent /> : <BlankReasonContainer />}
    </DTSelectedItemTransactionView>
  );
};

export default withConfirmation(DTRefundAndCancelSelectedItemsNode);
